// Disc type is stored as an int (0..3) in both the user's discs (`to`) and the brand
// catalog molds (`to`).
const TYPE_NAMES = ['Driver', 'Fairway', 'Midrange', 'Putter']

export const discTypeName = (type) =>
  type != null && TYPE_NAMES[type] ? TYPE_NAMES[type] : '—'

// The disc `color` (`c`) is an Android ARGB int (may be a signed 32-bit value). A value of
// 0 is Color.Transparent, which the app treats as "no colour". Returns a `#rrggbb` string
// or null when there is no usable colour.
export const colorToCss = (color) => {
  if (!color) return null
  const rgb = color & 0xffffff
  if (rgb === 0) return null
  return `#${rgb.toString(16).padStart(6, '0')}`
}
